


































































import { Component, Vue, Prop, Ref } from 'vue-property-decorator';
import { mapState } from 'vuex';

@Component({
  computed: {
    ...mapState('ShareCode', {
      newShareCode: 'shareCode',
    }),
  },
})
export default class CandidateDashboardShareCode extends Vue {
  @Prop() readonly title!: string;
  @Prop() readonly subTitle!: string;
  @Ref() readonly shareCodeValidation!: { setErrors: (any?: any) => void };
  @Ref() readonly codeInput!: { values: string[] };

  newShareCode!: '';

  shareCode = '';
  disableAutoFetch = false;
  isLoading = false;

  allowedChars = [
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z',
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g',
    'h',
    'i',
    'j',
    'k',
    'l',
    'm',
    'n',
    'o',
    'p',
    'q',
    'r',
    's',
    't',
    'u',
    'v',
    'w',
    'x',
    'y',
    'z',
  ];

  get shareCodeLocal() {
    this.codeInput.values = this.codeInput.values.map(
      (x) => x && x.toUpperCase()
    );
    return this.codeInput.values.join('').toUpperCase();
  }

  get showDialog() {
    return this.newShareCode != null;
  }

  handleComplete() {
    if (!this.disableAutoFetch) {
      this.fetch();
    }
  }

  submit() {
    this.fetch();
  }

  fetch() {
    this.isLoading = true;
    this.$store
      .dispatch('ShareCode/validate', this.shareCodeLocal)
      .then((response) => {
        if (!response.data.data.booking) {
          // this.shareCode = ''
          this.shareCodeValidation.setErrors(['Invalid Share Code!']);
          this.disableAutoFetch = true;
        } else {
          this.disableAutoFetch = false;
          this.$store.commit(
            'BookingCandidate/SET_BOOKING_CANDIDATE',
            response.data.data.booking_candidate
          );
          this.$store.commit('Booking/SET_STATE', {
            key: 'booking',
            payload: response.data.data.booking,
          });
          this.$emit('complete', response.data.data.booking.questionnaire);
        }
      })
      .catch(({ response }) => {
        console.debug(response);
        if (response.data.is_user_input_error) {
          this.shareCodeValidation.setErrors([response.data.error]);
        }
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  claimNewShareCode() {
    this.codeInput.values = this.newShareCode.split('');
    this.fetch();
    this.$store.commit('ShareCode/RESET_SHARE_CODE');
  }

  dismissNewShareCode() {
    this.$store.commit('ShareCode/RESET_SHARE_CODE');
  }
}
